import { all, fork } from "redux-saga/effects";
import homeSagas from "~/store/home/homeSagas";
import supporter from "~/store/supporter/supporterSaga";
import patientForm from "~/store/patientForm/patientFormSaga";
import patient from "~/store/patient/patientSaga";
import clinic from "~/store/clinic/clinicSaga";
import prescribe from "~/store/prescribe/prescribeSaga";
import fee from "~/store/fee/feeSaga";
import rebooking from "~/store/rebooking/rebookingSaga";
import dateAndSpecialist from "~/store/dateAndSpecialist/dateAndSpecialistSagas";
import room from "~/store/room/roomSaga";
import notification from "~/store/notifications/notificationsSaga";
import umcSubmitPayment from "~/sagas/umcSubmitPayment";
import healthInsuranceCard from "~/sagas/healthInsuranceCard";
import contact from "~/store/contact/contactSaga";
import faq from "~/store/faq/faqSaga";
import user from "~/store/user/userSaga";
import resource from "~/store/resource/resourceSaga";
import hospital from "~/store/hospital/hospitalSaga";
import features from "~/store/features/featuresSaga";
import booking from "~/store/booking/bookingSaga";
import payment from "~/store/payment/paymentSaga";
import doctorSaga from "~/store/doctor/doctorSaga";
import totalDataSaga from "~/store/totalData/sagas";
import followUpExam from "~/store/followUpExam/sagas";
import invoice from "~/store/invoice/sagas";
import partnerUser from "~/store/partnerUser/sagas";
import login from "~/store/login/sagas";
import filter from "~/store/filter/sagas";
import CustomerService from "~/store/customerService/customerServiceSaga";
import appDeposit from "~/store/appDepositPayment/sagas";

export default function* rootSaga() {
  yield all([
    fork(homeSagas),
    fork(user),
    fork(supporter),
    fork(patientForm),
    fork(patient),
    fork(clinic),
    fork(prescribe),
    fork(fee),
    fork(dateAndSpecialist),
    fork(room),
    fork(payment),
    fork(notification),
    fork(umcSubmitPayment),
    fork(healthInsuranceCard),
    fork(contact),
    fork(faq),
    fork(resource),
    fork(hospital),
    fork(features),
    fork(booking),
    fork(rebooking),
    fork(doctorSaga),
    fork(totalDataSaga),
    fork(followUpExam),
    fork(invoice),
    fork(partnerUser),
    fork(login),
    fork(filter),
    fork(CustomerService),
    fork(appDeposit)
  ]);
}
